<div class="nxt-dropdown-container" 
    [class.disabled]="isDisabled"
    [class.open]="isOpen"
    [class.required]="isRequiredInvalid"
    [class.floatlabel-enabled]="_config.floatlabel"
    [class.infield-label]="_config.infieldLabel"
    [class.floatlabel-onfield-enabled]="_config.floatlabel && _config.floatlabelPosition === 'onfield'"
  >
  
  <!-- Trigger Container (supports default and custom trigger content) -->
  <div #dropdownTrigger cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin"
       class="nxt-dropdown-trigger" 
       [class.infield-label-mode]="_config.infieldLabel"
       (click)="toggleDropdown()"
       (keydown)="onKeyDown($event)"
       tabindex="0"
       role="combobox"
  >
    
    <!-- Labels -->
    <ng-container *ngIf="_config.infieldLabel">
      <div class="nxt-dropdown-infield-label" 
           *ngIf="_config.infieldLabelPosition === 'infield'"
           [class.active]="isOpen || selectedOptions.length > 0">
        <span class="nxt-dropdown-label-text">{{ getInfieldLabelText() }}<span class="nxt-dropdown-required-asterisk" *ngIf="isRequired"> *</span></span>
        <span *ngIf="labelSuffixRef" class="nxt-dropdown-label-suffix"><ng-container [ngTemplateOutlet]="labelSuffixRef.templateRef"></ng-container></span>
        <span *ngIf="!labelSuffixRef && _config.labelSuffixHtml" class="nxt-dropdown-label-suffix" [innerHTML]="getSanitizedIcon(_config.labelSuffixHtml)"></span>
      </div>
      
      <div class="nxt-dropdown-onfield-label" 
           *ngIf="_config.infieldLabelPosition === 'onfield'"
           [class.active]="isOpen || selectedOptions.length > 0">
        <span class="nxt-dropdown-label-text">{{ getInfieldLabelText() }}<span class="nxt-dropdown-required-asterisk" *ngIf="isRequired"> *</span></span>
        <span *ngIf="labelSuffixRef" class="nxt-dropdown-label-suffix"><ng-container [ngTemplateOutlet]="labelSuffixRef.templateRef"></ng-container></span>
        <span *ngIf="!labelSuffixRef && _config.labelSuffixHtml" class="nxt-dropdown-label-suffix" [innerHTML]="getSanitizedIcon(_config.labelSuffixHtml)"></span>
      </div>
    </ng-container>

    <ng-container *ngIf="_config.floatlabel">
      <div class="nxt-dropdown-float-infield-label" 
           *ngIf="_config.floatlabelPosition === 'infield'"
           [class.active]="isOpen || selectedOptions.length > 0">
        <span class="nxt-dropdown-label-text">{{ getFloatLabelText() }}<span class="nxt-dropdown-required-asterisk" *ngIf="isRequired"> *</span></span>
        <span *ngIf="labelSuffixRef" class="nxt-dropdown-label-suffix"><ng-container [ngTemplateOutlet]="labelSuffixRef.templateRef"></ng-container></span>
        <span *ngIf="!labelSuffixRef && _config.labelSuffixHtml" class="nxt-dropdown-label-suffix" [innerHTML]="getSanitizedIcon(_config.labelSuffixHtml)"></span>
      </div>
      
      <div class="nxt-dropdown-float-onfield-label" 
           *ngIf="_config.floatlabelPosition === 'onfield'"
           [class.active]="isOpen || selectedOptions.length > 0">
        <span class="nxt-dropdown-label-text">{{ getFloatLabelText() }}<span class="nxt-dropdown-required-asterisk" *ngIf="isRequired"> *</span></span>
        <span *ngIf="labelSuffixRef" class="nxt-dropdown-label-suffix"><ng-container [ngTemplateOutlet]="labelSuffixRef.templateRef"></ng-container></span>
        <span *ngIf="!labelSuffixRef && _config.labelSuffixHtml" class="nxt-dropdown-label-suffix" [innerHTML]="getSanitizedIcon(_config.labelSuffixHtml)"></span>
      </div>
    </ng-container>
    
    <!-- Value Display (replaced by custom trigger content when provided) -->
    <div class="nxt-dropdown-value" 
         [class.infield-label-mode]="_config.infieldLabel"
         [class.infield-label-infield-mode]="_config.infieldLabel && _config.infieldLabelPosition === 'infield'"
         [class.floatlabel-infield-mode]="_config.floatlabel && _config.floatlabelPosition === 'infield'"
         [class.floatlabel-infield-active]="_config.floatlabel && _config.floatlabelPosition === 'infield' && (selectedOptions.length > 0)">

      <ng-container *ngIf="hasCustomTrigger; else defaultValueTpl">
        <ng-content select="nxt-dropdown-trigger"></ng-content>
      </ng-container>

      <ng-template #defaultValueTpl>
        <ng-container *ngIf="selectedOptions.length === 0; else selectedContent">
          <div class="nxt-dropdown-placeholder">{{ _config.placeholder }}</div>
        </ng-container>
        
        <ng-template #selectedContent>
          <div class="nxt-dropdown-selected">
            <div class="nxt-dropdown-single" *ngIf="!_config.multiple">
              {{ getDisplayText() }}
            </div>
            
            <div class="nxt-dropdown-multiple" *ngIf="_config.multiple">
              <div class="nxt-dropdown-text">{{ getDisplayText() }}</div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
    
    <!-- Arrow Icon -->
    <div class="nxt-dropdown-arrow">
      <svg [attr.data-icon-type]="_config.iconType" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <!-- Caret -->
        <path *ngIf="_config.iconType === 'caret'" 
              d="M3 4.5L6 7.5L9 4.5" 
              stroke="currentColor" 
              stroke-width="1.5" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
        
        <!-- Arrow -->
        <path *ngIf="_config.iconType === 'arrow'" 
              d="M6 2L6 10M6 10L3 7M6 10L9 7" 
              stroke="currentColor" 
              stroke-width="1.5" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
        
        <!-- Sharp Caret -->
        <polygon *ngIf="_config.iconType === 'sharp-caret'" 
                 points="3,4.5 6,7.5 9,4.5" 
                 fill="currentColor"/>
        
        <!-- Inverted Triangle -->
        <polygon *ngIf="_config.iconType === 'inverted-triangle'" 
                 points="2,3 6,9 10,3" 
                 fill="currentColor"/>
      </svg>
    </div>
  </div>
  
  <!-- Connected overlay panel -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayScrollStrategy]="repositionScroll"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayWidth]="overlayWidth"
    (backdropClick)="closeDropdown()"
    (detach)="onOverlayDetach()"
  >
  <div class="nxt-dropdown-dropdown nxt-dropdown-overlay-panel" 
       [ngClass]="_config.panelClass"
       [class.confirmation-mode]="_config.confirmation && _config.multiple && filteredOptions.length > 0"
       [class.virtual-scroll-enabled]="shouldEnableVirtualScroll()"
       (keydown.escape)="closeDropdown()">
    
    <!-- Search Input -->
    <div class="nxt-dropdown-search" *ngIf="_config.searchable && showSearchInput">
      <div class="nxt-dropdown-search-container">
        <div class="nxt-dropdown-option nxt-dropdown-all-option beside-select-all"
        *ngIf="(_config.selectAllPosition === 'beside') && shouldShowSelectAll() && options.length > 0"
        [class.selected]="isAllAvailableSelected()"
        [class.partially-selected]="isPartiallyAvailableSelected()"
        (click)="selectAll(); $event.stopPropagation()"
        role="option"
           >
     
          <div class="nxt-dropdown-option-content">
            <div class="nxt-dropdown-option-checkbox">
              <div class="nxt-dropdown-checkbox" 
                    [class.checked]="isAllAvailableSelected()"
                    [class.partially]="isPartiallyAvailableSelected()">
                <svg *ngIf="isAllAvailableSelected()" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6L5 9L10 3" 
                        stroke="white" 
                        stroke-width="2" 
                        stroke-linecap="round" 
                        stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="isPartiallyAvailableSelected()" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M3 6H9" 
                        stroke="white" 
                        stroke-width="2" 
                        stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
        <input #searchInput
               class="nxt-dropdown-search-input"
               [placeholder]="_config.searchPlaceholder"
               [value]="searchText"
               (input)="onSearchInput($event)"
               (keydown)="onSearchKeyDown($event)"
               autocomplete="off"
               spellcheck="false">
        <span class="nxt-dropdown-search-icon" *ngIf="!searchText">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M20 20L16.65 16.65" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <button type="button" 
                class="nxt-dropdown-search-clear"
                *ngIf="searchText"
                (click)="clearSearchText(); $event.stopPropagation()"
                >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px;">
            <path d="M18 6L6 18M6 6L18 18" 
                  stroke="currentColor" 
                  stroke-width="1.5" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Options Container -->
    <div class="nxt-dropdown-options" [class.virtual-scroll-enabled]="shouldEnableVirtualScroll()">
      <!-- Select All Option -->
      <div class="nxt-dropdown-option nxt-dropdown-all-option"
           *ngIf="(_config.selectAllPosition === 'below') && shouldShowSelectAll() && options.length > 0"
           [class.selected]="isAllAvailableSelected()"
           [class.partially-selected]="isPartiallyAvailableSelected()"
           (click)="selectAll(); $event.stopPropagation()"
           role="option"
           >
        
        <div class="nxt-dropdown-option-content">
                      <div class="nxt-dropdown-option-checkbox">
              <div class="nxt-dropdown-checkbox" 
                   [class.checked]="isAllAvailableSelected()"
                   [class.partially]="isPartiallyAvailableSelected()">
                <svg *ngIf="isAllAvailableSelected()" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6L5 9L10 3" 
                        stroke="white" 
                        stroke-width="2" 
                        stroke-linecap="round" 
                        stroke-linejoin="round"/>
                </svg>
                <svg *ngIf="isPartiallyAvailableSelected()" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M3 6H9" 
                        stroke="white" 
                        stroke-width="2" 
                        stroke-linecap="round"/>
                </svg>
              </div>
            </div>
          
          <div class="nxt-dropdown-option-label">
            <strong>Select All</strong>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="nxt-dropdown-divider" *ngIf="(_config.selectAllPosition === 'below') && shouldShowSelectAll() && options.length > 0"></div>
      
      <!-- Virtual Scrolling Options -->
      <cdk-virtual-scroll-viewport 
          *ngIf="shouldEnableVirtualScroll()"
          [itemSize]="virtualScrollItemSize"
          [minBufferPx]="virtualScrollMinBufferPx"
          [maxBufferPx]="virtualScrollMaxBufferPx"
          [style.height.px]="virtualScrollViewportHeight"
          (scrolledIndexChange)="onVirtualScrollIndexChanged($event)"
          class="nxt-dropdown-virtual-scroll-viewport">
        
                 <ng-container *cdkVirtualFor="let option of filteredOptions; let i = index; trackBy: trackByFilteredOption">
           <!-- Group Header -->
           <div class="nxt-dropdown-group-header" 
               *ngIf="option.group && shouldShowGroupHeader(option, i)"
               [class.group-selectable]="_config.multiple"
               role="option"
               (click)="onGroupHeaderClick(option.group, $event)">
            <ng-container *ngIf="_config.multiple; else groupLabelOnlyVirtual">
              <div class="nxt-dropdown-option-content">
                <div class="nxt-dropdown-option-checkbox">
                  <div class="nxt-dropdown-checkbox" 
                       [class.checked]="isGroupAllSelected(option.group!)"
                       [class.partially]="isGroupPartiallySelected(option.group!)">
                    <svg *ngIf="isGroupAllSelected(option.group!)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" 
                            stroke="white" 
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round"/>
                    </svg>
                    <svg *ngIf="!isGroupAllSelected(option.group!) && isGroupPartiallySelected(option.group!)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M3 6H9" 
                            stroke="white" 
                            stroke-width="2" 
                            stroke-linecap="round"/>
                    </svg>
                  </div>
                </div>
                <div class="nxt-dropdown-option-label">{{ option.group }}</div>
              </div>
            </ng-container>
            <ng-template #groupLabelOnlyVirtual>
              {{ option.group }}
            </ng-template>
           </div>
          
          <!-- Option -->
          <div class="nxt-dropdown-option"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="isOptionRuntimeDisabled(option)"
               [class.grouped]="option.group"
               (click)="selectOption(option); $event.stopPropagation()"
               role="option"
               >
            
            <div class="nxt-dropdown-option-content">
              <div class="nxt-dropdown-option-checkbox" *ngIf="_config.multiple">
                <div class="nxt-dropdown-checkbox" [class.checked]="isOptionSelected(option)">
                  <svg *ngIf="isOptionSelected(option)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6L5 9L10 3" 
                          stroke="white" 
                          stroke-width="2" 
                          stroke-linecap="round" 
                          stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              
              <div class="nxt-dropdown-option-label" 
                   [attr.title]="!option.templateRef ? option.label : null"
                   >
                <ng-container *ngIf="!option.templateRef; else projectedTpl1">{{ option.label }}</ng-container>
                <ng-template #projectedTpl1>
                  <ng-container *ngTemplateOutlet="option.templateRef"></ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </cdk-virtual-scroll-viewport>
      
      <!-- Standard Options (when virtual scroll is disabled) -->
      <ng-container *ngIf="!shouldEnableVirtualScroll()">
        <ng-container *ngFor="let option of filteredOptions; let i = index; trackBy: trackByFilteredOption">
          <!-- Group Header -->
          <div class="nxt-dropdown-group-header" 
               *ngIf="option.group && shouldShowGroupHeader(option, i)"
               [class.group-selectable]="_config.multiple"
               role="option"
               (click)="onGroupHeaderClick(option.group, $event)">
            <ng-container *ngIf="_config.multiple; else groupLabelOnlyStandard">
              <div class="nxt-dropdown-option-content">
                <div class="nxt-dropdown-option-checkbox">
                  <div class="nxt-dropdown-checkbox" 
                       [class.checked]="isGroupAllSelected(option.group!)"
                       [class.partially]="isGroupPartiallySelected(option.group!)">
                    <svg *ngIf="isGroupAllSelected(option.group!)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6L5 9L10 3" 
                            stroke="white" 
                            stroke-width="2" 
                            stroke-linecap="round" 
                            stroke-linejoin="round"/>
                    </svg>
                    <svg *ngIf="!isGroupAllSelected(option.group!) && isGroupPartiallySelected(option.group!)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M3 6H9" 
                            stroke="white" 
                            stroke-width="2" 
                            stroke-linecap="round"/>
                    </svg>
                  </div>
                </div>
                <div class="nxt-dropdown-option-label">{{ option.group }}</div>
              </div>
            </ng-container>
            <ng-template #groupLabelOnlyStandard>
              {{ option.group }}
            </ng-template>
          </div>
          
          <!-- Option -->
          <div class="nxt-dropdown-option"
               [class.selected]="isOptionSelected(option)"
               [class.disabled]="isOptionRuntimeDisabled(option)"
               [class.grouped]="option.group"
               (click)="selectOption(option); $event.stopPropagation()"
               role="option"
               >
            
            <div class="nxt-dropdown-option-content">
              <div class="nxt-dropdown-option-checkbox" *ngIf="_config.multiple">
                <div class="nxt-dropdown-checkbox" [class.checked]="isOptionSelected(option)">
                  <svg *ngIf="isOptionSelected(option)" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6L5 9L10 3" 
                          stroke="white" 
                          stroke-width="2" 
                          stroke-linecap="round" 
                          stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              
              <div class="nxt-dropdown-option-label" 
                   [attr.title]="!option.templateRef ? option.label : null"
                   >
                <ng-container *ngIf="!option.templateRef; else projectedTpl2">{{ option.label }}</ng-container>
                <ng-template #projectedTpl2>
                  <ng-container *ngTemplateOutlet="option.templateRef"></ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      
      <!-- No Options Message -->
      <div class="nxt-dropdown-no-options" *ngIf="filteredOptions.length === 0">
        <div *ngIf="_config.searchable && searchText && searchText.length >= _config.minSearchLength">
          No options found for "{{ searchText }}"
        </div>
        <div *ngIf="!_config.searchable || !searchText || searchText.length < _config.minSearchLength">
          No options available
        </div>
      </div>
    </div>

    <!-- Confirmation Footer -->
    <div class="nxt-dropdown-footer" *ngIf="_config.confirmation && _config.multiple && filteredOptions.length > 0">
      <div class="nxt-dropdown-footer-buttons">
        <button type="button" 
                class="nxt-dropdown-btn nxt-dropdown-btn-cancel"
                (click)="cancelSelection(); $event.stopPropagation()">
          <span *ngIf="_config.confirmationButtons?.cancel?.icon" 
                class="nxt-dropdown-btn-icon" 
                [innerHTML]="getSanitizedIcon(_config.confirmationButtons?.cancel?.icon)"></span>
          {{ _config.confirmationButtons?.cancel?.text }}
        </button>
        <button type="button" 
                class="nxt-dropdown-btn nxt-dropdown-btn-apply"
                [disabled]="shouldDisableApplyButton()"
                (click)="applySelection(); $event.stopPropagation()">
          <span *ngIf="_config.confirmationButtons?.apply?.icon" 
                class="nxt-dropdown-btn-icon" 
                [innerHTML]="getSanitizedIcon(_config.confirmationButtons?.apply?.icon)"></span>
          {{ _config.confirmationButtons?.apply?.text }}
        </button>
      </div>
    </div>
  </div>
  </ng-template>
</div> 